import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, catchError, map, throwError } from "rxjs";
import { AuthService } from "./auth.service";
import { MessageService } from "primeng/api";
import { EncryptionService } from "./encryption.service";
import { environment } from "src/environments/environment";
import { TranslocoService } from "@ngneat/transloco";

@Injectable({
    providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
    constructor(private authService: AuthService, private messageService: MessageService, private router: Router, private encryptionService: EncryptionService,public transloco: TranslocoService) { }
    private activeMessages: Set<string> = new Set();
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Add authentication token if available
        const token = this.authService.getUserToken();
        // if (token) {
        //     request = request.clone({
        //         setHeaders: {
        //             Authorization: `Bearer ${token}`,
        //         },
        //     });
        // }


        if (request.url.indexOf('/assets/i18n') == -1) {
           // 
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
        // Encryption disabled - backend EncryptionMiddleware is disabled
        // Payloads are sent as plain JSON to match backend configuration
        // let payload;
        // // Intercept only POST requests
        // if (request.method === "POST") {
        //     // Encrypt request payload
        //     if (request.body instanceof FormData) {
        //         payload = request.body;
        //     } else {
        //         payload = this.encryptionService.encryptPayload(
        //             JSON.stringify(request.body)
        //         );
        //     }
        //     request = request.clone({
        //         body: payload,
        //     });
        // }
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                this.handleErrorResponse(error);
                return throwError(() => error);
            })
        );
    }

    private handleErrorResponse(error: HttpErrorResponse): void {
        if (error.status === 401) {
            // Route to /auth/sign-in for 401 errors
            this.router.navigate(["/auth/sign-in"]);
        } else if (error.status === 403) {
            // Handle 403 errors
            this.messageService.add({
                severity: "error",
                summary: "Forbidden",
                detail:
                    "You do not have permission to perform this action.",
            });
        } else {
            // Exclude certain endpoints from showing error messages
            const excludedUrls = [
                'createuser',
                'createrole',
                'CreateCompany',
                'search-user-by-email',
                'ad-users',
                'validate-user'
            ];
            
            const shouldExclude = excludedUrls.some(url => error.url?.includes(url));
            
            // Also exclude CORS/network errors (status 0) for any endpoint
            const isCorsError = error.status === 0 || 
                               error.statusText === 'Unknown Error' ||
                               error.message?.includes('CORS') ||
                               error.message?.includes('Network');
            
            if(shouldExclude || isCorsError){
                return;
            }
            else{
                let errorMessage = `Error: ${error.error.message}`;
                this.addMessage({
                    severity: "error",
                    summary: "Error",
                    detail: errorMessage == "Error: undefined" ? this.transloco.translate('technical-error') : errorMessage,
                });
            } 
        }
    }
    addMessage(message: { severity: string; summary: string; detail: string; key?: string }) {
        const messageKey = this.generateMessageKey(message);
        if (!this.activeMessages.has(messageKey)) {
            this.messageService.add(message);
            this.activeMessages.add(messageKey);
            setTimeout(() => this.activeMessages.delete(messageKey), 3000);
          }
      }
    private generateMessageKey(message: { severity: string; summary: string; detail: string }): string {
        return `${message.severity}-${message.summary}-${message.detail}`;
      }
}
